var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-list',{ref:"gamelist",attrs:{"provider":_vm.provider,"save":_vm.save,"sync":_vm.sync,"edit":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/games/list.vue?vue&type=template&id=0bd31e75
// module id = EXxO
// module chunks = 0